import { TwSelectOption } from '../components/TwSelects/TwSelects';
import { LoadDocumentType } from '../redux/api/load/load.model';
import { Order, OrderAttachment } from '../redux/api/orders/orders.model';
import LoadsService from '../providers/Loads/Loads.service';
import { isWebInFlutter } from './browserUtils';
import FileUtils from './fileUtils';

class DocumentUtils {
  /**
   * Gets document type options to populate selects
   * @returns TwSelectOption[]
   */
  static getDocTypeOptions = (): TwSelectOption[] => {
    const options: TwSelectOption[] = [
      {
        label: 'Rate confirmation',
        value: LoadDocumentType.rateConfirmation
      },
      {
        label: 'Proof of delivery',
        value: LoadDocumentType.proofOfDelivery
      },
      {
        label: 'Bill of lading',
        value: LoadDocumentType.billOfLading
      },
      {
        label: 'Lumper',
        value: LoadDocumentType.lumper
      },
      {
        label: 'Receipt',
        value: LoadDocumentType.receipt
      },
      {
        label: 'Invoice',
        value: LoadDocumentType.invoice
      },
      {
        label: 'Other',
        value: LoadDocumentType.other
      }
    ];

    return options;
  };

  static getVisibilityOptions = (): TwSelectOption[] => {
    const options: TwSelectOption[] = [
      {
        label: 'Visible to driver',
        value: 'visible'
      },
      {
        label: 'Hidden from driver',
        value: 'hidden'
      }
    ];
    return options;
  };

  static handleOrderDownloadDoc = async (
    order: Order | null,
    doc: OrderAttachment
  ): Promise<void> => {
    const isFlutterApp = isWebInFlutter();
    if (doc?.attachment?.s3_signed_download_url && isFlutterApp) {
      FileUtils.fetchAndDownloadFileLinkClick(doc.attachment.s3_signed_download_url);
    } else {
      const docSrc = await LoadsService.getLoadFile(doc.id);
      const docLink = URL.createObjectURL(docSrc);
      const docName = doc && 'attachment' in doc ? doc.attachment.name : null;
      const docKey = doc && 'attachment' in doc ? doc.attachment.key : null;

      const link = document.createElement('a');
      link.href = docLink || '';
      link.download = docName
        ? `Order#${order?.readable_id}-${docName}`
        : docKey
        ? `Order#${order?.readable_id}-${docKey}`
        : `Order#${order?.readable_id}-attachment.pdf`;

      link.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        docLink && window.URL.revokeObjectURL(docLink);
      }, 100);
    }
  };
}

export default DocumentUtils;
